import React from 'react';
import { Box, Chip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../../components/customPagination';
import { useGetUsersHandler } from '../dataHandlers/getUsersHandler';
import UserActions from './UserActions';
import {USER_STATUS_LABELS} from "../../../constants/peppolStatusConstants";

const getStatusChip = (status, labels) => {
  if (status === 'invited') {
    return <Chip label={labels.invited} size="small" variant="outlined" />;
  }
  if (status === 'active') {
    return <Chip label={labels.active} size="small" color="primary" />;
  }
  if (status === 'inactive') {
    return <Chip label={labels.inactive} size="small" color="warning" variant="outlined" />;
  }
  return <Chip label={status} size="small" />;
};

export default function UsersTable({ onEdit, searchQuery = {}, handlePaginationChange }) {
  const { users, totalElements, isLoading } = useGetUsersHandler({ searchQuery });

  const columns = [
    {
      field: 'name',
      headerName: 'User',
      flex: 1,
    },
    {
      field: 'email',
      headerName:  'Email',
      flex: 1.5,
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.8,
      renderCell: ({ row }) => getStatusChip(row.status, USER_STATUS_LABELS),
    },
    {
      field: 'actions',
      headerName:  'Actions',
      flex: 0.6,
      sortable: false,
      filterable: false,
      renderCell: ({ row }) => <UserActions user={row} onEdit={onEdit} />,
    },
  ];

  return (
    <Box>
      <DataGrid
        rows={users}
        columns={columns}
        getRowId={(row) => row.id}
        paginationMode="server"
        rowCount={totalElements}
        loading={isLoading}
        disableRowSelectionOnClick
        autoHeight
        paginationModel={{
          page: searchQuery.page ?? 0,
          pageSize: searchQuery.size ?? 10,
        }}
        pageSizeOptions={[10, 25, 50]}
        onPaginationModelChange={(model) => {
          handlePaginationChange(model.page, model.pageSize);
        }}
        slots={{ pagination: CustomPagination }}
      />
    </Box>
  );
}
